<template>
  <div v-if="models.data" class="form-control input-container" style="border: none">
    <div class="input-group" style="border: 1px solid var(--primary-color); border-bottom: none">
      <div class="form-floating filter-input" style="width: calc(100% - 42px)">
        <form-input
          :id="name + '-search'"
          v-model="search"
          class="form-control border-start-0 border-end-0 border-top-0"
          type="text"
          @keyup="(event) => searchModels(event.target.value)"
        />
        <label :for="name + '-search'">Suchen...</label>
      </div>
      <div class="input-group-append" @click="searchModels()">
        <span class="input-group-text h-100 border-end-0 border-top-0">
          <i class="fa fa-search"></i>
        </span>
      </div>
    </div>
    <div class="relation-results">
      <ul class="list-unstyled m-0">
        <li
          v-for="(model, key) in models.data"
          :key="key"
          class="px-0 py-2 d-flex"
          style="line-height: 1.375rem; border-bottom: 1px solid rgba(0, 0, 0, 0.125)"
        >
          <span class="relation-id ps-1 pe-3 smaller text-muted flex-0">(ID: {{ model.data.id }})</span>
          <span class="pe-0 relation-title text-truncate flex-grow-1">{{ model.data.attributes.model_title }}</span>
          <span class="flex-0" style="cursor: pointer" @click="attach(model)">
            <i class="bi bi-plus-square" style="font-size: 1rem; color: #09ba62"></i>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FormInput from '@kanrisha/components/Elements/Form/TextInput';
import useModels from '@kanrisha/composables/useModels';
import { onMounted, ref } from 'vue';

export default {
  components: {
    FormInput,
  },
  props: {
    id: { type: String, default: null },
    error: { type: String, default: null },
    name: { type: String, default: null },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    label: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    origin: { type: Object, default: () => null },
    resourceType: { type: String, default: 'models' },
  },
  emits: ['update:attached'],
  setup(props, { emit }) {
    const { models, fetchModels } = useModels({ resourceType: props.resourceType });

    const filter = ref({ search: '' });
    const search = ref('');

    const searchModels = async (searchValue) => {
      filter.value.search = searchValue ? searchValue : 'RESET';
      fetchModels(
        {
          filter: filter.value,
          parent: props.origin?.meta.resourceType ?? null,
          relation: props.name ?? null,
        },
        'volatile'
      );
    };

    const attach = (attachedModel) => {
      emit('update:attached', attachedModel);
    };

    onMounted(() => {
      searchModels('');
    });

    return {
      searchModels,
      models,
      search,
      attach,
    };
  },
};
</script>
